module.exports = __webpack_public_path__ + "img/11.08a74a16.jpg";